import React from 'react';
import {Link} from 'react-router-dom'

const e = React.createElement;


function Register() {
  React.Component.constructor.call(this);

  this.state = {
    display_line:1,
  };
}
Register.prototype = Object.create(React.Component.prototype);

Register.prototype.componentDidMount = function() {
  document.getElementById("field1").addEventListener('keydown', this.handleKeydown.bind(this));
  document.getElementById("field2").addEventListener('keydown', this.handleKeydown.bind(this));
}

Register.prototype.componentWillUnmount = function() {
  document.getElementById("field1") && document.getElementById("field1").removeEventListener('keydown', this.handleKeydown.bind(this));
  document.getElementById("field2") && document.getElementById("field2").removeEventListener('keydown', this.handleKeydown.bind(this));
}


Register.prototype.render = function() {
  var tr_full = "Volledige naam";
  var tr_email = "E-mail";
  var tr_pass = "Wachtwoord";
  var tr_create = "Account maken";
  var tr_pressenter = "Druk op Enter";
  var tr_byreg = e('div', {key:"15", className:"footnote"}, [e('span', {key:"151"}, "Door een account te maken ga je akkoord met de "), e('a', {key:"152", href:"/terms", target:"_blank", rel:"noopener noreferrer"}, "Algemene Voorwaarden"), e('span', {key:"153"}, ".")]);

  if(this.props.language === "EN") {
    tr_full = "Full name";
    tr_email = "Email";
    tr_pass = "Password";
    tr_create = "Create account";
    tr_byreg = e('div', {key:"15", className:"footnote"}, [e('span', {key:"151"}, "By creating an account you agree to the "), e('a', {key:"152", href:"/terms", target:"_blank", rel:"noopener noreferrer"}, "Terms and Conditions"), e('span', {key:"153"}, ".")]);
    tr_pressenter = "Press Enter";
  }

  return e('div', {style:{maxWidth:"45%", minWidth:"180px", margin:"0 auto"}}, [
    e('form', {key:"1", onSubmit:this.props.handleRegister}, [
      this.state.display_line == 1 && e('div', {key:"13"}, e('input', {type:"text", id:"field1", value:this.props.email, onChange:this.props.handleChange.bind(this, "email"), placeholder:tr_email})),
      this.state.display_line == 1 && e('div', {key:"17"}, e('input', {type:"button", className:"btn btn-c btn-fat", value:(this.props.email === "" ? this.props.register_cta : tr_pressenter), disabled:(this.props.email === ""), onClick:this.setStep.bind(this, 2)})),
      e('div', {key:"11"}, e('input', {type:"text", id:"field2", style:{display:(this.state.display_line == 2 ? "block" : "none")}, value:this.props.fullname, onChange:this.props.handleChange.bind(this, "fullname"), placeholder:tr_full})),
      this.state.display_line == 2 && e('div', {key:"18"}, e('input', {type:"button", className:"btn btn-c btn-fat", value:tr_pressenter, disabled:(this.props.fullname === ""), onClick:this.setStep.bind(this, 3)})),
      this.state.display_line == 3 && e('div', {key:"14"}, e('input', {type:"password", id:"field3", value:this.props.password, onChange:this.props.handleChange.bind(this, "password"), placeholder:tr_pass})),
      this.state.display_line == 3 && tr_byreg,
      this.state.display_line == 3 && e('div', {key:"16"}, e('input', {type:"submit", value:tr_create, disabled:this.props.register_is_fetching})),
    ]),
  ]);
}

Register.prototype.setStep = function(new_step) {
  if(new_step === 2 && this.props.email !== "") {
    this.setState({display_line:new_step});
    setTimeout(function() {
      document.getElementById("field2").focus()
    }, 0);
  } else if(new_step === 3 && this.props.fullname !== "") {
    var full = this.props.fullname.split(" ");
    if(full[1]) {
      this.setState({display_line:new_step});
      setTimeout(function() {
        document.getElementById("field3").focus()
      }, 0);
    } else {
      if(this.props.language === "NL") {
        this.props.setAlert("Vul een achternaam in.");
      } else {
        this.props.setAlert("Fill in a last name.");
      }
    }
  }
}

Register.prototype.handleKeydown = function(e) {
  if(e.key === "Enter") e.preventDefault();
  if(e.key === "Enter" && e.target.id === "field1" && this.props.email !== "") {
    this.setState({display_line:2});
    setTimeout(function() {
      document.getElementById("field2").focus()
    }, 0);
  } else if(e.key === "Enter" && e.target.id === "field2" && this.props.fullname !== "") {
    var full = this.props.fullname.split(" ");
    if(full[1]) {
      this.setState({display_line:3});
      setTimeout(function() {
        document.getElementById("field3").focus()
      }, 0);
    } else {
      if(this.props.language === "NL") {
        this.props.setAlert("Vul een achternaam in.");
      } else {
        this.props.setAlert("Fill in a last name.");
      }
    }
  }
}

export default Register



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/components/LineFormAccount_Register.js
// module id = 220
// module chunks = 0